const KEY_USER_CUSTOM = 'user_custom_'

function loadUserCustom(type) {
    type = (type!==undefined)?type:0
    let r = JSON.parse(localStorage.getItem(KEY_USER_CUSTOM + type))

    if(r == null) {
        r = []
    }

    return r
}

function saveUserCustom(r, type) {
    type = (type!==undefined)?type:0
    localStorage.setItem(KEY_USER_CUSTOM + type, JSON.stringify(r))
}

function clear(type) {
    type = type?type:0
    localStorage.removeItem(KEY_USER_CUSTOM + type)
}

function getFinalList(origin, custom) {
    let list = []
    let oMap = {}
    let cMap = {}
    origin.forEach(element => {
        oMap[element.id] = element
    });
    custom.forEach(element => {
        cMap[element.id] = element
    });

    origin.forEach(element => {
        let custom = cMap[element.id]
        if(custom != null) {
            if(custom.delete) {
                return
            }
        } else {
            list.push(element)
        }
    })

    custom.forEach(element => {
        if(element.delete) {
            return
        }

        if(element.forSort) {
            list.push(oMap[element.id])
            return
        }

        list.push(element)
    });
    return list
}

export default {loadUserCustom: loadUserCustom, saveUserCustom, getFinalList, clear}



// WEBPACK FOOTER //
// ./src/utils/customSite.js